import { IPeriodLevel } from "./model";
import { notEmpty } from "./notEmpty";

export const findYearsLastPeriod = (
  activePeriod: string,
  levels: IPeriodLevel[]
) => {
  const currentPeriod = levels
    .map((level) => {
      return level.periods.filter((p) => p.name === activePeriod).pop();
    })
    .filter(notEmpty)
    .pop();

  const periods = levels
    .filter((level) => level.id === currentPeriod?.periodlevel)
    .map((level) => level.periods)
    .filter(notEmpty)
    .pop();

  if (currentPeriod && periods) {
    const yearOfCurrent = new Date(currentPeriod.startdate).getFullYear();
    return periods
      .filter((period) => {
        const yearOfPeriod = new Date(period.startdate).getFullYear();
        return yearOfPeriod === yearOfCurrent;
      })
      .sort((a, b) => {
        return a.startdate.localeCompare(b.startdate);
      })
      .pop();
  }
};
